import classNames from "classnames";
import * as React from "react";
import { IsMobileDevice } from "source/app/domain/Device/Helpers/IsMobile";
import { Style, StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import { webkitFilterGlitchFix } from "source/app/presentation/Shared/Styles/SharedStyles";

export const InnerProgressBar = ({
    progress,
    isAnimated,
}: {
    progress: number;
    isAnimated: boolean;
}) => {
    const width = isAnimated ? 100 : progress;

    return (
        <div
            id="innerProgressBar"
            className={classNames({
                [styleClass_animtedProgress_lowPerformance]:
                    isAnimated && IsMobileDevice(),
                [styleClass_animatedProgress_highPerformance]:
                    isAnimated && !IsMobileDevice(),
                [styleClass_regularProgress]: !isAnimated,
            })}
            {...GetAdditionalStyle(width)}
        />
    );
};

function GetAdditionalStyle(width: number) {
    return Style(`LevelProgressBar_innerProgressBar_${width}`, {
        width: `${width}%`,
        transition: IsMobileDevice()
            ? `none`
            : `width ${transitionTime + 200}ms`,
        ...webkitFilterGlitchFix,
    });
}

const styleClass_animtedProgress_lowPerformance = StyleClass(
    `lowPerformanceAnimatedBar`,
    {
        background: `linear-gradient(90deg, #8b692d, #c79a45 calc(100% - 10px), #ffe297)`,
        height: `3px`,
        boxShadow: `inset -1px 0 #fff0ae, 2px 0 5px rgba(241, 207, 114, 0.68)`,
    }
);

const styleClass_animatedProgress_highPerformance = StyleClass(
    `animatedProgress_highPerformance`,
    {
        height: "3px",
        animation: "levelProgressShimmer 1.2s infinite linear",
        background:
            "linear-gradient(90deg, #8b692d 0%, #c79a45 35%, #fff0ae 50%, #c79a45 65%, #8b692d 100%)",
        backgroundSize: "200% 100%",
        boxShadow: `inset -1px 0 #fff7cd, 2px 0 6px rgba(241, 207, 114, 0.78)`,
    }
);

const styleClass_regularProgress = StyleClass(
    `levelProgressBar_innerProgressBar_regularProgress`,
    {
        background:
            "linear-gradient(90deg, #795e2b, #b88b3e calc(100% - 10px), #ead07d)",
        boxShadow: `inset -1px 0 rgba(255, 241, 185, 0.85), 2px 0 4px rgba(222, 188, 99, 0.48)`,
        opacity: 0.88,
        height: "3px",
    }
);

const transitionTime = 1000;
